import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Renwu from "../pages/renwu/page";
import Shijian from "../pages/shijian/page";
import EventDetail from "../pages/shijian/detail/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/renwu",
    element: <Renwu />,
  },
  {
    path: "/shijian",
    element: <Shijian />,
  },
  {
    path: "/shijian/:id",
    element: <EventDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;